import * as React from 'react'
import * as styles from './premium-tag.module.scss'


export const PremiumGradient = () => {
    return (<svg width="0" height="0" viewBox="0 0 10 10" fill="none" style={{display: 'block'}} xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient id="premium-tag-gradient-light" x1="1.81818" y1="8.75" x2="7.80184" y2="0.679804" gradientUnits="userSpaceOnUse">
                <stop offset="0.25" stopColor="#653DD2" />
                <stop offset="1" stopColor="#B41FFF" />
            </linearGradient>
            <linearGradient id="premium-tag-gradient-dark" x1="1.81818" y1="8.75" x2="7.80184" y2="0.679804" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="1" stopColor="#E0A2FF" />
            </linearGradient>
        </defs>
    </svg>)
}

export const PremiumTag = ({className}) => {
    return (<>
        <div className={`${styles.wrap} ${className || ''}`} title='Premium'>
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M6.40108 4.0625H3.59892L5 7.33169L6.40108 4.0625ZM6.40108 3.4375H3.59892L4.26856 1.875H5.73144L6.40108 3.4375ZM7.08106 4.0625L5.93864 6.72815L8.27108 4.0625H7.08106ZM7.08106 3.4375L6.41142 1.875H7.1875L8.35938 3.4375H7.08106ZM2.91894 3.4375L3.58858 1.875H2.8125L1.64062 3.4375H2.91894ZM4.06136 6.72815L2.91894 4.0625H1.72892L4.06136 6.72815ZM9.375 3.75L5 8.75L0.625 3.75L2.5 1.25H7.5L9.375 3.75Z" fill="var(--premium-tag-url)" />
            </svg>
        </div>
    </>);
}

export const PremiumTagLarge = () => {
    return (<>
        <div className={styles.wrapLarge}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M10.2417 6.5H5.75827L8 11.7307L10.2417 6.5ZM10.2417 5.5H5.75827L6.8297 3H9.1703L10.2417 5.5ZM11.3297 6.5L9.50183 10.765L13.2337 6.5H11.3297ZM11.3297 5.5L10.2583 3H11.5L13.375 5.5H11.3297ZM4.6703 5.5L5.74173 3H4.5L2.625 5.5H4.6703ZM6.49817 10.765L4.6703 6.5H2.76627L6.49817 10.765ZM15 6L8 14L1 6L4 2H12L15 6Z" fill="var(--premium-tag-url)" />
            </svg>
            <span className={styles.text}>Premium</span>
        </div>
    </>)
}
